module.exports = __webpack_public_path__ + "static/media/feature-realtime-scoring.53771134.png";